import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "b163ee82-33ff-42ce-be28-012e8fb51bc5",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-1.svg`,
    },
  },
  {
    id: "4dbd634c-e4c0-48d4-bc84-4144b553539b",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-2.svg`,
    },
  },
  {
    id: "79b6726d-109b-4e06-8881-6b244c4d6327",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-3.svg`,
    },
  },
  {
    id: "327a1934-54e8-43d0-814f-9f16bb88e713",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-4.svg`,
    },
  },
  {
    id: "df626f1a-5fb9-40aa-9196-b873e1a539e9",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-5.svg`,
    },
  },
  {
    id: "5ddede52-b99d-4a7a-a96d-c6ae1a407175",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-6.svg`,
    },
  },
  {
    id: "4272b962-78d5-467f-b99a-ec4fb96afa24",
    options: {
      imageUrl: `${config.ASSETS_URL}/03/04/task/task-6-item-7.svg`,
    },
  },
];

export const task: Task = {
  id: "4159a79a-b2ca-4a12-88eb-f818777ddbe5",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    orientation: "horizontal",
    imageViewType: "contain",
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "b163ee82-33ff-42ce-be28-012e8fb51bc5",
    "df626f1a-5fb9-40aa-9196-b873e1a539e9",
    "4272b962-78d5-467f-b99a-ec4fb96afa24",
    "79b6726d-109b-4e06-8881-6b244c4d6327",
    "327a1934-54e8-43d0-814f-9f16bb88e713",
    "5ddede52-b99d-4a7a-a96d-c6ae1a407175",
    "4dbd634c-e4c0-48d4-bc84-4144b553539b",
  ],
};
